import React, { useContext } from 'react';
import styled, { ThemeContext } from 'styled-components';
import Projects from './Projects';
import PortfolioFooter from './PortfolioFooter';
import Container from '../../components/Container';
import DecorationsWhite from '../../components/DecorationsWhite';
import ContainerFullWidth from '../../components/ContainerFullWidth';
import useWindowWidth from '../../hooks/useWindowWidth';
import ContactUsButton from '../../components/ContactUsButton';
import useContactBtnPosition from '../../hooks/useContactBtnPosition';


const Wrapper = styled.div`
  background-color: ${({ theme }) => theme.colors.blue};
  min-height: 100vh;
`;

const PortfolioLayout = () => {
  const { screenSizeWidthWithoutPx, colors } = useContext(ThemeContext);
  const windowSize = useWindowWidth();
  const position = useContactBtnPosition({ position: 'fixed', top: 'unset', bottom: '26px' });

  return (
    <Wrapper>
      {windowSize !== 0 && (
        <ContainerFullWidth
          noPadding
          backgroundColor={colors.blue}
        >
          <Container>
            <Projects />
            <PortfolioFooter />
          </Container>
          <DecorationsWhite
            height="510px"
            width={(windowSize >= screenSizeWidthWithoutPx.small) ? '20%' : '0'}
            top="30px"
            left="0"
            side="left"
          />
          <DecorationsWhite
            height="350px"
            width={(windowSize >= screenSizeWidthWithoutPx.medium) ? '30%' : '50%'}
            bottom={(windowSize >= screenSizeWidthWithoutPx.medium) ? '100px' : '0'}
            right="0"
            side="right"
          />
          {windowSize >= screenSizeWidthWithoutPx.small
          && (
            <ContactUsButton
              linkAddress="contact"
              width={100}
              height={85}
              position={position.position}
              bottom={position.bottom}
              top={position.top}
              right="15px"
            />
          )}
        </ContainerFullWidth>
      )}
    </Wrapper>
  );
};

export default PortfolioLayout;
